import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  getAdminStock,
  adminStockLogs,
  adminStockTransaction,
  getAdminStockHistory,
} from "data/server_apis/inventoryService";

const adminStockAdapter = createEntityAdapter({
  selectId: (adminStock) => adminStock.id,
});

const adminStockLogAdapter = createEntityAdapter({
  selectId: (log) => log.id,
});

export const adminStockTransactionThunk = createAsyncThunk(
  "adminStock/create",
  async ({ stock, data }, { rejectWithValue }) => {
    try {
      return (await adminStockTransaction(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
export const getAdminStockLogsThunk = createAsyncThunk(
  "adminStockLogs/get",
  async ({ page, from_date, to_date, admin }, { rejectWithValue }) => {
    try {
      return (await adminStockLogs(page, from_date, to_date, admin))
        .data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getAdminStockThunk = createAsyncThunk(
  "adminStock/get",
  async (admin, { rejectWithValue }) => {
    try {
      return (await getAdminStock(admin)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getAdminStockHistoryThunk = createAsyncThunk(
  "adminStockHistory/get",
  async ({time,admin}, { rejectWithValue }) => {
    try {
      return (await getAdminStockHistory(time,admin)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const adminStockSlice = createSlice({
  name: "adminStack",
  initialState: adminStockAdapter.getInitialState({
    adminStockStatus: {},
    adminStockTransactionStatus: {},
    logs: adminStockLogAdapter.getInitialState(),
    logStatus: {},
    logPageCount: 1,
    history: [],
    historyStatus: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminStockTransactionThunk.pending, (state, action) => {
        state.adminStockTransactionStatus = { loading: "post" };
      })
      .addCase(adminStockTransactionThunk.rejected, (state, action) => {
        state.adminStockTransactionStatus = {
          error: "post",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(adminStockTransactionThunk.fulfilled, (state, action) => {
        state.adminStockTransactionStatus = {
          success: "post",
          errorMessage: action.payload?.message,
        };
        if (
          action.meta.arg.data.in_or_out === "ret" ||
          action.meta.arg.data.in_or_out === "out"
        ) {
          const stock = { ...action.meta.arg.stock };
          stock.qty -= action.payload.qty;
          adminStockAdapter.updateOne(state, {
            id: action.meta.arg.stock.id,
            changes: stock,
          });
        }
      });

    builder
      .addCase(getAdminStockThunk.pending, (state, action) => {
        state.adminStockStatus = { loading: "get" };
      })
      .addCase(getAdminStockThunk.rejected, (state, action) => {
        state.adminStockStatus = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(getAdminStockThunk.fulfilled, (state, action) => {
        state.adminStockStatus = {
          success: "get",
        };
        adminStockAdapter.setAll(state, action.payload);
      });

    builder.addCase(getAdminStockLogsThunk.fulfilled, (state, action) => {
      adminStockLogAdapter.setAll(state.logs, action.payload.results);
      state.logPageCount = action.payload.total_pages;
    });

    builder
      .addCase(getAdminStockHistoryThunk.pending, (state, action) => {
        state.getMainStockHistory = { loading: "get" };
      })
      .addCase(getAdminStockHistoryThunk.rejected, (state, action) => {
        state.getMainStockHistory = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(getAdminStockHistoryThunk.fulfilled, (state, action) => {
        state.getMainStockHistory = {
          success: "get",
        };
        state.history = action.payload;
      });
  },
});

export const {} = adminStockSlice.actions;
export const adminStockSelector = adminStockAdapter.getSelectors(
  (state) => state.adminStock
);

export const adminStockLogSelector =
  adminStockLogAdapter.getSelectors(
    (state) => state.adminStock.logs
  );

export default adminStockSlice.reducer;
